import * as React from "react";
import LoadingData from "../../loadingData/loadingData.component";
import i18next, { t } from "i18next";
import { IoClose } from "react-icons/io5";
import NoData from "../../noData/noData.component";

type PropsTypes = {
  isOpen: boolean;
  close: () => void;
  jobRoleLinked: any[];
  typeData: string;
};

const ViewJobRoleLinkedModal: React.FC<PropsTypes> = ({
  isOpen,
  close,
  jobRoleLinked,
  typeData,
}) => {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  return (
    <>
      {!isLoading && (
        <div
          className={`flex flex-col gap-3 fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-white w-1/2 max-h-[90vh] p-6 py-12 !z-[999999] overflow-y-auto duration-300 ${
            isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex justify-between items-center">
            <h2 className="text-3xl mb-6 text-text">
              {t(
                typeData == "user"
                  ? "job_role_linked_users"
                  : "job_role_linked_staff",
              )}
            </h2>
            <button onClick={close} className="text-5xl mb-6">
              <IoClose />
            </button>
          </div>
          {jobRoleLinked?.length === 0 && (
            <NoData message={t("no_Job_Roles")} />
          )}
          {jobRoleLinked?.length > 0 && (
            <div className="w-full overflow-x-auto">
              <table className="w-full border-collapse mt-5">
                <thead>
                  <tr className="border-collapse border-2">
                    <th
                      className={`border-collapse border-2 p-3 min-w-[50px] ${
                        i18next.language === "ar" ? "text-right" : "text-left"
                      }`}
                    >
                      {t("user_name")}
                    </th>
                    <th
                      className={`border-collapse border-2 p-3 min-w-[200px] ${
                        i18next.language === "ar" ? "text-right" : "text-left"
                      }`}
                    >
                      {t("staff_phone")}
                    </th>
                    <th
                      className={`border-collapse border-2 p-3 min-w-[200px] ${
                        i18next.language === "ar" ? "text-right" : "text-left"
                      }`}
                    >
                      {t(typeData == "user" ? "user_type" : "national_id")}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="h-6">
                    <td></td>
                  </tr>
                  {jobRoleLinked?.map((role: any, index: number) => (
                    <tr key={index} className="border-collapse border-2">
                      <td
                        className={`border-collapse border-2 p-3 min-w-[50px] ${
                          i18next.language === "ar" ? "text-right" : "text-left"
                        }`}
                      >
                        {typeData == "user"
                          ? role.asdc_client_user_name
                          : role.asdc_client_staff_name}
                      </td>
                      <td
                        className={`border-collapse border-2 p-3 min-w-[200px] ${
                          i18next.language === "ar" ? "text-right" : "text-left"
                        }`}
                      >
                        <div className="flex items-center justify-between">
                          <span>
                            {typeData == "user"
                              ? role?.asdc_client_user_mobile
                              : role?.asdc_client_staff_phone}
                          </span>
                        </div>
                      </td>
                      <td
                        className={`border-collapse border-2 p-3 min-w-[200px] ${
                          i18next.language === "ar" ? "text-right" : "text-left"
                        }`}
                      >
                        <div className="flex items-center justify-between">
                          <span>
                            {typeData == "user"
                              ? role.asdc_client_user_type
                              : role.NationalID}
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
      {isLoading && <LoadingData />}
      <div
        className={`bg-black ${
          isOpen ? "opacity-60" : "opacity-0 pointer-events-none"
        } fixed inset-0 z-[99999] flex items-center justify-center transition-all duration-500`}
        onClick={close}
      ></div>
    </>
  );
};

export default ViewJobRoleLinkedModal;
